import { UseFormReturnType } from '@mantine/form'
import { MILESTONE_ACTION_STATE_KEYS } from '../vlmPipelineConfig'
import { PipelineFormValues } from './VlmPipelineForm'

// Shared by the Actions step's "Next" gate and each ActionCard's "Save
// action" button, so the two can never drift on which fields an action
// needs filled in.
export const actionHasErrors = (
  form: UseFormReturnType<PipelineFormValues>,
  index: number
): boolean => {
  const action = form.values.actions[index]
  const results = [form.validateField(`actions.${index}.alert_tags`)]

  if (action.type === 'email') {
    results.push(form.validateField(`actions.${index}.recipients`))
  }

  if (action.type === 'milestone') {
    results.push(form.validateField(`actions.${index}.milestone_server_id`))
    MILESTONE_ACTION_STATE_KEYS.forEach((key) => {
      results.push(form.validateField(`actions.${index}.states.${key}.name`))
      results.push(form.validateField(`actions.${index}.states.${key}.level`))
    })
  }

  return results.some((result) => result.hasError)
}
